var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"prefix":_vm.prefix,"title":"Partner","doc":_vm.doc}},[_c('GroupTiles',{attrs:{"groups":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }